import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from 'locales/en';
import pt_BR from 'locales/pt_BR';
import es from 'locales/es';

const resources = {
  en,
  pt_BR,
  es
}; 


i18n.use(initReactI18next).init({
  resources,
  lng: 'pt_BR',
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
